import { useState } from "react";
import emailjs from "@emailjs/browser";
import React from "react";
import { Loading, EmployName } from '../shared/constants/texts.js';


const initialState = {
  from_name: "",
  from_email: "",
  message: "",
};

const Toast = ({ message, type, onClose }) => {
  if (!message) return null;

  const bgColor = type === 'success' 
    ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
    : 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)';
  
  const icon = type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle';

  return (
    <div style={{
      position: 'fixed',
      top: '20px',
      right: '20px',
      background: bgColor,
      color: '#fff',
      padding: '16px 20px',
      borderRadius: '12px',
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      minWidth: '300px',
      maxWidth: '500px',
      animation: 'slideInRight 0.3s ease-out'
    }}>
      <i className={`fa-solid ${icon}`} style={{ fontSize: '20px' }}></i>
      <span style={{ flex: 1, fontSize: '14px', fontWeight: '500' }}>{message}</span>
      <button
        onClick={onClose}
        style={{
          background: 'rgba(255,255,255,0.2)',
          border: 'none',
          color: '#fff',
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '14px',
          transition: 'background 0.2s'
        }}
        onMouseEnter={(e) => e.target.style.background = 'rgba(255,255,255,0.3)'}
        onMouseLeave={(e) => e.target.style.background = 'rgba(255,255,255,0.2)'}
      >
        ×
      </button>
    </div>
  );
};

export const Contact = (props) => {
  const [{ from_name, from_email, message }, setState] = useState(initialState);
  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  React.useEffect(() => {
    if (process.env.REACT_APP_PUBLIC_KEY) {
      emailjs.init(process.env.REACT_APP_PUBLIC_KEY);
    }
  }, []);

  const showToast = (message, type) => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: '', type: '' });
    }, 5000);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const templateParams = {
      from_name: from_name,
      from_email: from_email,
      message: message,
      message_html: message,
      to_name: 'Cortex Prime Solutions'
    };

    emailjs
      .send(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        templateParams
      )
      .then(
        (result) => {
          clearState();
          showToast('Mensagem enviada com sucesso! Entraremos em contato em breve.', 'success');
          setIsSubmitting(false);
        },
        (error) => {
          showToast(
            'Erro ao enviar mensagem. Por favor, tente novamente ou entre em contato por telefone.',
            'error'
          );
          setIsSubmitting(false);
        }
      );
  };
  return (
    <div>
      {toast.show && (
        <Toast 
          message={toast.message} 
          type={toast.type}
          onClose={() => setToast({ show: false, message: '', type: '' })}
        />
      )}
      
      <div id="contact">
        <div className="container">
          <div className="col-md-7">
            <div className="row">
              <div className="section-title">
                <h2>Fale conosco</h2>
                <p>
                  Utilize o formulário abaixo para nos enviar um e-mail e
                  entraremos em contato com você o mais rápido possível.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="from_name"
                        name="from_name"
                        className="form-control"
                        placeholder="Nome"
                        required
                        onChange={handleChange}
                        value={from_name}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="from_email"
                        name="from_email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                        value={from_email}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Mensagem"
                    required
                    onChange={handleChange}
                    value={message}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button 
                  type="submit" 
                  className="btn btn-custom btn-lg"
                  disabled={isSubmitting}
                  style={{
                    opacity: isSubmitting ? 0.7 : 1,
                    cursor: isSubmitting ? 'not-allowed' : 'pointer'
                  }}
                >
                  {isSubmitting ? (
                    <>
                      <i className="fa-solid fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                      Enviando...
                    </>
                  ) : (
                    'Enviar'
                  )}
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-4 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Informações de contatos</h3>
              <p>
                <span>
                  <i className="fa-solid fa-location-dot"></i> Endereço
                </span>
                {props.data ? props.data.address1 : Loading}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa-solid fa-phone"></i> Telefone
                </span>{" "}
                {props.data ? props.data.phone : Loading}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa-brands fa-whatsapp"></i> Whatsapp
                </span>{" "}
                {props.data ? props.data.whatsapp : Loading}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa-solid fa-envelope"></i> Email
                </span>{" "}
                {props.data ? props.data.email : Loading}
              </p>
            </div>
          </div>

          {/* <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa-brands fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa-brands fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i className="fa-brands fa-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div> */}

        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <div style={{ marginBottom: '20px' }}>
            <p style={{ 
              fontSize: '16px', 
              fontWeight: '600', 
              color: '#cbd5e1',
              marginBottom: '8px'
            }}>
              {EmployName}
            </p>
            
            {/* <p style={{ 
              fontSize: '14px', 
              color: '#94a3b8',
              marginBottom: '4px'
            }}>
              CNPJ: 00.000.000/0000-00
            </p> */}

            <p style={{ 
              fontSize: '13px', 
              color: '#94a3b8',
              marginBottom: '0'
            }}>
              {props.data ? props.data.address1 : Loading}
            </p>
          </div>
          
          {/* <div style={{ 
            marginBottom: '20px',
            paddingTop: '20px',
            borderTop: '1px solid #1e293b'
          }}>
            <Link 
              to="/politica-privacidade" 
              style={{ 
                color: '#60a5fa',
                fontSize: '14px',
                margin: '0 15px',
                transition: 'color 0.2s ease',
                textDecoration: 'none'
              }}
            >
              Política de Privacidade
            </Link>
            <span style={{ color: '#475569' }}>•</span>
            <Link 
              to="/termos-de-uso" 
              style={{ 
                color: '#60a5fa',
                fontSize: '14px',
                margin: '0 15px',
                transition: 'color 0.2s ease',
                textDecoration: 'none'
              }}
            >
              Termos de Uso
            </Link>
          </div> */}

          <p style={{ fontSize: '14px', color: '#94a3b8', marginBottom: '0' }}>
            &copy; {new Date().getFullYear()} {EmployName}. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </div>
  );
};
